import { useContext } from "react";
import { SignalRClientMethod, SignalRServerMethod } from "../constants";
import { SignalRContext } from "../SignalRContext";
import { SignalRTaskItemsContext } from "./SignalRTaskItemsContext";

interface Props {
  children?: React.ReactNode;
}

const SignalRTaskItemsProvider = (props: Props) => {
  const context = useContext(SignalRContext);

  return (
    <SignalRTaskItemsContext.Provider
      value={{
        sendRefetchTaskItem: (...args) => context.invoke(SignalRServerMethod.SendRefetchTaskItem, args),
        sendRefetchTeamTaskItems: (...args) => context.invoke(SignalRServerMethod.SendRefetchTeamTaskItems, args),
        sendRefetchUserTaskItems: (...args) => context.invoke(SignalRServerMethod.SendRefetchUserTaskItems, args),
        onShouldRefetchTaskItem: (handler) =>
          context.registerHandler(SignalRClientMethod.ShouldRefetchTaskItem, handler),
        offShouldRefetchTaskItem: (handler) =>
          context.unregisterHandler(SignalRClientMethod.ShouldRefetchTaskItem, handler),
        onShouldRefetchTeamTaskItems: (handler) =>
          context.registerHandler(SignalRClientMethod.ShouldRefetchTeamTaskItems, handler),
        offShouldRefetchTeamTaskItems: (handler) =>
          context.unregisterHandler(SignalRClientMethod.ShouldRefetchTeamTaskItems, handler),
        onShouldRefetchUserTaskItems: (handler) =>
          context.registerHandler(SignalRClientMethod.ShouldRefetchUserTaskItems, handler),
        offShouldRefetchUserTaskItems: (handler) =>
          context.unregisterHandler(SignalRClientMethod.ShouldRefetchUserTaskItems, handler),
      }}
    >
      {props.children}
    </SignalRTaskItemsContext.Provider>
  );
};

export { SignalRTaskItemsProvider };
